import React, { useState, useEffect } from "react";
import { DataGrid } from "@mui/x-data-grid";
import axios from "axios";
import moment from "moment/moment";
const assetsCol = [
  { field: "lastEvent", headerName: "Event Time/Date", width: 200 },
  { field: "type", headerName: "Event Type", width: 100 },
  { field: "name", headerName: "Name", width: 200 },
  {
    field: "timeSinceLastUpdated",
    headerName: "Time Since Last Updated",
    width: 200,
  },
  { field: "lastKnownLoc", headerName: "Last known Address", width: 200 },
  { field: "lastKnowLatLng", headerName: "Last known Lat/Lng", width: 150 },
];
export default function EventDataTable(props) {
  const [trackablesList, setTrackablesList] = useState([]);
  // Get Vehicle list and append to state
  useEffect(() => {
    // for local testing
    //var token =
    //  "eyJraWQiOiJuc3BpcmUiLCJ0eXAiOiJKV1QiLCJhbGciOiJSUzI1NiJ9.eyJzdWIiOiJkdmlkbXljaHRlc3QyQHNwaXJlb24uY29tIiwibnM6YXMiOiJwYWFzIiwibnM6c2dpIjpbXSwibnM6c2MiOiJwYWFzIiwiaXNzIjoiaHR0cHM6XC9cL3NwaXJlb24uY29tIiwibnM6YXBwIjoiNTZmN2FiYTUtNGMxYS0xMWVjLThjYzMtMDI0MmFjMTIwMDA4IiwibnM6dCI6ImR2aWRteWNodGVzdDJAc3BpcmVvbi5jb20rNTZmN2FiYTUtNGMxYS0xMWVjLThjYzMtMDI0MmFjMTIwMDA4IiwibnM6cyI6IkFDQ09VTlRfVVNFUl9TQ09QRSIsIm5zOnYiOiJ2MSIsIm5zOnUiOiIzNWM0ZWY1NS04OGI1LTQyYmYtODVmYy1mYTNlNThmNzQwNWUiLCJuczphYiI6InBhYXMiLCJuczpyb2xlIjpbIlJPTEVfQUNDT1VOVF9BRE1JTiIsIlJPTEVfQ09OU1VNRVIiLCJST0xFX0RFQUxFUiIsIlJPTEVfUEFBU19BRE1JTl9BTEwiLCJST0xFX1BBQVNfQURNSU5fQ1JFQVRFX0FMTCIsIlJPTEVfUEFBU19BRE1JTl9ERUxFVEVfQUxMIiwiUk9MRV9QQUFTX0FETUlOX1JFQURfQUxMIiwiUk9MRV9QQUFTX0FETUlOX1VQREFURV9BTEwiLCJST0xFX1BBQVNfVVNFUiIsIlJPTEVfUEFBU19XRUJIT09LX0FETUlOIiwiUk9MRV9QQUFTX1dFQkhPT0tfVVNFUiIsIlJPTEVfVEVMRU1FVFJZX1BST1ZJREVSIiwiUk9MRV9VU0VSIl0sImV4cCI6MTY4MDAzNjQ2NywibnM6YiI6InBhYXMiLCJuczphIjoiMTY0MzA2MTkxMzU1MU5RRFhWUTEifQ.YrsL3RBrY1DMfEuy55YiSPqezJvJLBsTLkvneyZh707G9I0JGXfHcqSaGlhx_PrHrNMGbVnulo4YAOWxbgwH8KavkyApDSIsUSMMbFwKCmP4OleBQksgcCCD8vPIgTE-qtVn6lg5B_UAXs0CLUeS501_jWlfL-p4MNbfbugw-1HBswlniQ3tJNl5PhgLkLIRPlTcE-0h6WJFXdSjahBketzYXoH6b8-fhsf9Gvlcs_0SBnIG80X_sm7CG3msy3lnBWn_WnUZiAZ8LuVNxxi-v3NJ90JaZesjIjCpX_iC9A_-Pv05_16149USjO9JXkeRr1QM8vEYdB9cj4tThTo9Eg";
    // for dynamic
    const authToken = localStorage.getItem("authToken");
    //const authToken = JSON.parse(localStorage.getItem("authToken")).token;
    console.log(authToken);
    //without API
    const instance = axios.create({
      baseURL: "https://paas-api-proxy-stage.spireon.com/",
      timeout: 100000,
      //for local testing
      //headers: { Authorization: "Bearer " + token },
      //for dynamic
      headers: { Authorization: "Bearer " + JSON.parse(authToken).token },
    });

    const func = async () => {
      let res = await instance.get("/v1/stated-trackables");
      let content = await res.data.content;
      debugger;
      let tList;
      console.log(content);
      tList = content.map((val) => {
        return {
          lastEvent: val.asset?.lastUpdated,
          type: val.asset?.type,
          name: val.asset?.name,
          timeSinceLastEvent: "",
          id: val.id,
          timeSinceLastUpdated: moment(
            moment.duration(moment().utc().diff(moment(val.asset?.lastUpdated)))
          ).format("hh:mm:ss"),
          lastKnowLoc:
            (val.state.lastLocation?.address
              ? val.state.lastLocation.address.line1
                ? val.state.lastLocation.address.line1
                : ""
              : "") +
            "," +
            (val.state.lastLocation?.address
              ? val.state.lastLocation.address.city
                ? val.state.lastLocation.address.city
                : ""
              : "") +
            "," +
            (val.state.lastLocation?.address
              ? val.state.lastLocation.address.stateOrProvince
                ? val.state.lastLocation.address.stateOrProvince
                : ""
              : "") +
            "," +
            (val.state.lastLocation?.address
              ? val.state.lastLocation.address.postalCode
                ? val.state.lastLocation.address.postalCode
                : ""
              : ""),
          lastKnowLatLng:
            val.state.lastLocation?.lat + "/" + val.state.lastLocation?.lng,
          status: val.asset.active ? "Active" : "Inactive",
        };
      });
      setTrackablesList(tList);
      //dispatch(sktrDetailsSlice.actions.setVehicleList(vList));
    };
    func();
  }, []);
  return (
    <div style={{ height: 300, width: "100%" }}>
      <DataGrid
        rows={trackablesList}
        columns={assetsCol}
        pageSize={3}
        rowsPerPageOptions={[5]}
        //checkboxSelection
      />
    </div>
  );
}
